export interface TerminalGateType {
  id: string,
  name: string
}

export const TerminalGateFrom: TerminalGateType[] = [
  {id:"CHANGI AIRPORT TERMINAL 1", name:"GROUND TRANSPORT CONCIERGE TERMINAL 1"},
  {id:"AIRPORT BOULEVARD CHANGI AIRPORT TERMINAL 2 BUILDING", name:"GROUND TRANSPORT CONCIERGE TERMINAL 2"},
  {id:"CHANGI AIRPORT TERMINAL 3", name:"GROUND TRANSPORT CONCIERGE TERMINAL 3"},
  {id:"CHANGI AIRPORT TERMINAL 4", name:"GROUND TRANSPORT CONCIERGE TERMINAL 4"},
]

export const TerminalGateTo: TerminalGateType[] = [
  {id:"CHANGI AIRPORT TERMINAL 1", name:"CHANGI AIRPORT TERMINAL 1"},
  {id:"AIRPORT BOULEVARD CHANGI AIRPORT TERMINAL 2 BUILDING", name:"CHANGI AIRPORT TERMINAL 2"},
  {id:"CHANGI AIRPORT TERMINAL 3", name:"CHANGI AIRPORT TERMINAL 3"},
  {id:"CHANGI AIRPORT TERMINAL 4", name:"CHANGI AIRPORT TERMINAL 4"},
]
